









































import { Vue, Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { schoolClassModule } from '../store/modules/entities/school-class.module';
import { SchoolClass } from '../models/school-class/school-class';
import { BulkUpdateSchoolClassesRequest } from '@/models/school-class/school-class-bulk-update';
import { GPageBase } from '@/mixins';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GSchoolClassEntryModal',
  computed: {},
  methods: {},
})
export default class GSchoolClassEntryModal extends Mixins(GPageBase) {
  schoolClassColumns: any[] = [];
  showConfirmModal: boolean = false;
  currentPage: number = 1;
  pageSize: number = 10;

  @Prop({ default: false }) value: boolean;
  @Prop({ default: (): SchoolClass[] => [] }) srcSchoolClasses: SchoolClass[];
  @Watch('value')
  openModal(value: boolean) {
    this.showConfirmModal = value;
    this.currentPage = 1;
  }

  mounted() {
    this.schoolClassColumns = [
      {
        title: this.$t('UPDATE_DATA').toString(),
        slot: 'action',
        width: 100,
        align: 'center',
      },
      {
        title: this.$t('GRADE').toString(),
        slot: 'grade',
        width: 150,
        align: 'center',
      },
      {
        title: this.$t('SCHOOL_CLASS_NAME').toString(),
        slot: 'schoolClassName',
        align: 'center',
      },
    ];
  }

  get flattenSchoolClassesByPage(): SchoolClass[] {
    return this.flattenSchoolClasses.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
  }

  get flattenSchoolClasses(): SchoolClass[] {
    return schoolClassModule.flattenSchoolClasses;
  }

  handlePagerChange(pageNum: number) {
    this.currentPage = pageNum;
  }

  handleCancel() {
    this.$emit('input', false);
  }

  handleUpdate() {
    // クラス一括更新
    schoolClassModule
      .bulkUpdateSchoolClasses({
        updateSchoolClasses: this.flattenSchoolClasses.filter((sc: SchoolClass) => !sc.deleted && sc.changed),
        addSchoolClasses: this.flattenSchoolClasses.filter((sc: SchoolClass) => sc.created),
        deleteSchoolClassIDs: this.flattenSchoolClasses.filter((sc: SchoolClass) => sc.deleted).map((sc: SchoolClass) => sc.schoolClassID),
      } as BulkUpdateSchoolClassesRequest)
      .then(() => {
        // Success notice

        const updateCount: number = this.flattenSchoolClasses.filter((sc: SchoolClass) => {
          return (!sc.deleted && sc.changed) || sc.changed || sc.created || sc.deleted;
        }).length;
        this.showNotice(GEnum.MessageType.Success, this.$t('NOTICE.TITLE.UPDATE_COMPLETED').toString(), this.$t('MESSAGE_UPDATE_CLASS', {value: updateCount}).toString(), 10);

        // close dialog
        this.$emit('input', false);

        this.isRunning = true;
        this.lazyAction(() => {
          this.isRunning = false;
          window.location.reload();
        }, 5000);
      });
  }

  rowBgColor(rowSchoolClass: SchoolClass) {
    if (rowSchoolClass.deleted) return 'delete-row';
  }
}
